exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".preview > div {\n  float: left;\n  border: 1px solid pink;\n  margin-right: 20px; }\n.preview.selected > div {\n  position: relative;\n  margin-right: 20px; }\n.preview.selected i {\n  position: absolute;\n  cursor: pointer;\n  background: white;\n  bottom: 0;\n  right: 0;\n  color: red; }\n.preview img, .preview .img {\n  width: 300px;\n  height: auto; }\n.preview img.selected {\n  width: 600px; }\n.preview.bank {\n  max-height: 800px;\n  overflow: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/admin/preview/preview.component.css
// module id = 357
// module chunks = 2